import {
    HTML_VIDEO_IFRAME_ID,
    HTML_VIRTUALS_VIDEO_MUTE_ID,
    HTML_VIRTUALS_VIDEO_PLAYER_ID
} from "../constants/identifiers";
import {setVideoMuted} from "../actions/systemActions";
import {openCloseHelpPages} from "../actions/helpPagesActions";

export function generateGetStateCommand() {
    let getStateCommand = {
        jsonrpc: '2.0',
        id: '?!',
        method: 'GetState',
        params: {}
    };

    return JSON.pretify(getStateCommand);
}

export function isLocalStorageAvailable() {
    let test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

export function isLocalStorageQuotaExceeded(e) {
    var quotaExceeded = false;
    if (e) {
        if (e.code) {
            switch (e.code) {
                case 22:
                    quotaExceeded = true;
                    break;
                case 1014:
                    // Firefox
                    if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                        quotaExceeded = true;
                    }
                    break;
                default:
                    // some other erro eccured
                    quotaExceeded = true;
                    break;
            }
        } else if (e.number === -2147024882) {
            // Internet Explorer 8
            quotaExceeded = true;
        }
    }
    return quotaExceeded;
}

export function muteUnmuteGame(dispatch) {
    // this solution can malfunction if Manchester Team ends up changing the id of their divs
    // preamble and video frames have different ids
    let iframeContent = window.document.getElementById(HTML_VIDEO_IFRAME_ID).contentDocument;
    if (iframeContent !== undefined && iframeContent !== null) {
        let webPlayer = iframeContent.getElementById(HTML_VIRTUALS_VIDEO_PLAYER_ID);
        if (webPlayer !== undefined && webPlayer !== null) {
            webPlayer.muted = !webPlayer.muted;
            dispatch(setVideoMuted(webPlayer.muted))
        }
    } else {
        console.error('video iframe content empty');
    }
}

// window.parent.postMessage('gcm:{"method":"optionHasChanged","params":["ABOUT",true]}', '*')
export function handleGcmMessage(message, store) {
    let data = message.data;
    let gemJsonIdentifier = 'gcm:';
    if (data !== undefined && (typeof data === 'string' || data instanceof String)) {
        if (data.startsWith(gemJsonIdentifier)) {
            let gcmJson = data.slice(data.indexOf(gemJsonIdentifier) + gemJsonIdentifier.length);
            let gcm = JSON.parse(gcmJson);
            console.log(gcm)
            if (gcm.method === 'optionHasChanged') {
                if (gcm.params[0] === 'MUTE') {
                    if (gcm.params[1] !== store.getState().vpp.isVideoMuted) {
                        muteUnmuteGame(store.dispatch)
                    }
                } else if (gcm.params[0] === 'ABOUT') {
                    console.log('gcm.params[1]', gcm.params[1])
                    console.log('store.getState().vpp.isHelpPagesOpen', store.getState().vpp.isHelpPagesOpen)
                    if (gcm.params[1] !== store.getState().vpp.isHelpPagesOpen) {
                        store.dispatch(openCloseHelpPages());
                    }
                }

            }
        }
    }
}

export function gameActionHandler(name, value, store) {
    if (name === 'mute') {
        let isMute = value;
        let iframeContent = window.document.getElementById(HTML_VIDEO_IFRAME_ID).contentDocument;
        if (iframeContent !== undefined && iframeContent !== null) {
            let webPlayer = iframeContent.getElementById(HTML_VIRTUALS_VIDEO_PLAYER_ID);
            if (webPlayer !== undefined && webPlayer !== null) {
                webPlayer.muted = isMute;
                store.dispatch(setVideoMuted(webPlayer.muted));
                let inggPlayerFirstTime = iframeContent.getElementById(HTML_VIRTUALS_VIDEO_MUTE_ID);
                if (inggPlayerFirstTime !== undefined && inggPlayerFirstTime !== null) {
                    if (!isMute) {
                        inggPlayerFirstTime.style.background = "none";
                    } else {
                        inggPlayerFirstTime.style.background = "url('assets/first.png')";
                    }
                }
            }
        }
    } else if (name === 'help') {
        let isHelpPageOpen = store.getState().vpp.isHelpPagesOpen;
        if (isHelpPageOpen !== value) {
            store.dispatch(openCloseHelpPages());
        }
    }
}


// WEBPACK FOOTER //
// ./src/helpers/systemHelpers.js